if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector('.card__variant-select select');
      this.form = this.querySelector('form');
      this.productUrl = this.dataset.handle;
      this.init();
    }
    
    init() {
      
      let ratingWidget = this.querySelector('[data-yotpo-instance-id]');
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidget == 'function' && ratingWidget) {
        window?.yotpoWidgetsContainer.initWidget(ratingWidget?.dataset.yotpoInstanceId, ratingWidget);
      }
      
      if (this.select) {
        
        this.select.addEventListener('variantChange', () => {
          fetch(`${window.Shopify.routes.root}products/${this.productUrl}?variant=${this.select.value}&sections=product-card`)
            .then(res => res.json())
            .then(res => {
              let newSection = res['product-card'];
              
              let html = new DOMParser()
              .parseFromString(newSection, 'text/html')
              .querySelector('.shopify-section');
              
              this.parentElement.innerHTML = html.innerHTML;
            });
        });
      }
    }
  }

  customElements.define('product-card', ProductCard);
}